import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import ReleaseZone from './release-zone-model'
import {
  CreateReleaseZoneAsync,
  DeleteReleaseZoneAsync,
  LoadReleaseZonesAsync,
} from './releaseZone-thunk'
const initialState: releaseZoneSliceState = {
  releaseZone: [],
  selected_releaseZone: '',
  is_loading_releaseZone: false,
  is_creating_releaseZone: false,
  is_deleting_releaseZone: false,
}
export interface releaseZoneSliceState {
  releaseZone: ReleaseZone[]
  selected_releaseZone?: string
  is_loading_releaseZone: boolean
  is_creating_releaseZone: boolean
  is_deleting_releaseZone: boolean
}
export const releaseZoneSlice = createSlice({
  name: 'releaseZone',
  initialState,
  reducers: {
    setSelectedreleaseZone: (state, action) => {
      state.selected_releaseZone = action.payload
    },
    clearStatereleaseZone: (state) => {
      state.releaseZone = []
      state.is_loading_releaseZone = false
      state.is_creating_releaseZone = false
      state.is_deleting_releaseZone = false
    },
    mergereleaseZone: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_releaseZone = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.releaseZone = merge(state.releaseZone, payload) as any
        }
      }
    },

    add_releaseZone: (state, action) => {
      if (action.payload) {
        state.releaseZone = [...state.releaseZone, action.payload]
      }
    },
    set_releaseZone: (state, action) => {
      let { key, value, id } = action.payload
      state.releaseZone = state.releaseZone.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadReleaseZonesAsync.pending, (state) => {
      state.is_loading_releaseZone = true
    })
    builder.addCase(LoadReleaseZonesAsync.fulfilled, (state, action) => {
      state.is_loading_releaseZone = false
      if (action.payload) {
        state.releaseZone = action.payload
      }
    })
    builder.addCase(LoadReleaseZonesAsync.rejected, (state) => {
      state.is_loading_releaseZone = false
    })
    builder.addCase(CreateReleaseZoneAsync.pending, (state) => {
      state.is_creating_releaseZone = true
    })
    builder.addCase(CreateReleaseZoneAsync.fulfilled, (state) => {
      state.is_creating_releaseZone = false
    })
    builder.addCase(CreateReleaseZoneAsync.rejected, (state) => {
      state.is_creating_releaseZone = false
    })
    builder.addCase(DeleteReleaseZoneAsync.pending, (state) => {
      state.is_deleting_releaseZone = true
    })
    builder.addCase(DeleteReleaseZoneAsync.fulfilled, (state, action) => {
      state.is_deleting_releaseZone = false
      if (state.releaseZone) {
        state.releaseZone = state.releaseZone.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteReleaseZoneAsync.rejected, (state) => {
      state.is_deleting_releaseZone = false
    })

    builder.addCase(autoThunks.get_release_zones.pending, (state) => {
      state.is_loading_releaseZone = true
    })
    builder.addCase(autoThunks.get_release_zones.fulfilled, (state, action) => {
      state.is_loading_releaseZone = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.get_release_zones.rejected, (state) => {
      state.is_loading_releaseZone = false
    })

    builder.addCase(autoThunks.storeReleaseZoneAsync.pending, (state) => {
      state.is_loading_releaseZone = true
    })
    builder.addCase(
      autoThunks.storeReleaseZoneAsync.fulfilled,
      (state, action) => {
        state.is_loading_releaseZone = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.storeReleaseZoneAsync.rejected, (state) => {
      state.is_loading_releaseZone = false
    })

    builder.addCase(autoThunks.deleteReleaseZoneAsync.pending, (state) => {
      state.is_loading_releaseZone = true
    })
    builder.addCase(
      autoThunks.deleteReleaseZoneAsync.fulfilled,
      (state, action) => {
        state.is_loading_releaseZone = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.deleteReleaseZoneAsync.rejected, (state) => {
      state.is_loading_releaseZone = false
    })

    builder.addCase(
      autoThunks.get_release_zone_for_system_settings.pending,
      (state) => {
        state.is_loading_releaseZone = true
      },
    )
    builder.addCase(
      autoThunks.get_release_zone_for_system_settings.fulfilled,
      (state, action) => {
        state.is_loading_releaseZone = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_release_zone_for_system_settings.rejected,
      (state) => {
        state.is_loading_releaseZone = false
      },
    )
  },
})

function handleResult(action: any, state: releaseZoneSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_releaseZone = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.releaseZone = merge(state.releaseZone, payload) as any
    }
  }
}

export const {
  clearStatereleaseZone,
  setSelectedreleaseZone,
  set_releaseZone,
  mergereleaseZone,
  add_releaseZone,
} = releaseZoneSlice.actions

export const get_releaseZone =
  (id?: string) =>
  (state: {
    releaseZone: {
      releaseZone: ReleaseZone[]
    }
  }): ReleaseZone | null => {
    let temp = state?.releaseZone?.releaseZone?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.releaseZone?.releaseZone[0] || null
  }
export const get_selected_releaseZone = (state: {
  releaseZone: releaseZoneSliceState
}): ReleaseZone | null => {
  let id = state?.releaseZone?.selected_releaseZone
  let temp = state?.releaseZone?.releaseZone?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_releaseZone = (state: {
  releaseZone: {
    releaseZone: ReleaseZone[]
  }
}): ReleaseZone[] => {
  let temp = state?.releaseZone?.releaseZone
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_releaseZone_busy = (state: {
  releaseZone: releaseZoneSliceState
}) => {
  return (
    state?.releaseZone.is_deleting_releaseZone ||
    state?.releaseZone.is_loading_releaseZone ||
    state?.releaseZone.is_creating_releaseZone
  )
}
export const is_deleting_releaseZone_busy = (state: {
  releaseZone: releaseZoneSliceState
}) => {
  return state?.releaseZone.is_deleting_releaseZone
}
export const is_loading_releaseZone_busy = (state: {
  releaseZone: releaseZoneSliceState
}) => {
  return state?.releaseZone.is_loading_releaseZone
}
export const is_creating_releaseZone_busy = (state: {
  releaseZone: releaseZoneSliceState
}) => {
  return state?.releaseZone.is_creating_releaseZone
}

export default releaseZoneSlice.reducer
